import React from "react";
import UserIcon from "../../img/UserIcon.jsx";
import HouseIcon from "../../img/HouseIcon.jsx";
import EmailIcon from "../../img/EmailIcon.jsx";
import PencilIcon from "../../img/PencilIcon.jsx";
import IconClose from "../../img/IconClose.jsx";
import Spinner from "../Spínner/spinner1.js";

import {
  Container,
  ConteinerText,
  ContainerForm,
  ContainerInput,
  Input,
  TextArea,
  Button,
  ErrorFoms,
  ContainerSendForm,
  TextMessage,
} from "./style.js";
import useForm from "./useForm.js";
import { useScroll } from "../../context/UseContextScroll.js";
import { useTranslation } from "react-i18next";

const Form = () => {
  const { scroll } = useScroll();
  const [t] = useTranslation("global");

  const { formik, sendMessage, error, setSendMessage, setError, spinner } =
    useForm();
  const CloseSendForm = () => {
    setSendMessage(false);
  };
  const CloseErrorForm = () => {
    setError(false);
  };
  const errorFormik =
    formik.errors.company ||
    formik.errors.name ||
    formik.errors.email ||
    formik.errors.message;

  return (
    <Container
      id="contact"
      errorFormik={errorFormik}
      spinner={spinner}
      sendMessage={sendMessage}
      error={error}
    >
      {sendMessage || error ? (
        <ContainerSendForm sendMessage={sendMessage} error={error}>
          {error ? (
            <TextMessage error={error}>
              {t("buttonFormError.buttonFormError")}
            </TextMessage>
          ) : (
            <TextMessage sendMessage={sendMessage}>
              <strong>{t("Sent.Sent")} &nbsp;</strong>
              {t("staff.staff")}
              <strong> &nbsp;Proode</strong>
            </TextMessage>
          )}
          <div onClick={error ? CloseErrorForm : CloseSendForm}>
            <IconClose />
          </div>
        </ContainerSendForm>
      ) : (
        <>
          {" "}
          <ConteinerText
            scroll={scroll}
            sendMessage={sendMessage}
            error={error}
          >
            <h1>{t("titleForm.titleForm")}</h1>
            <p>{t("textForm.textForm")}</p>
          </ConteinerText>
          <form onSubmit={formik.handleSubmit}>
            <ContainerForm sendMessage={sendMessage} error={error}>
              <ContainerInput scroll={scroll}>
                <UserIcon />
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder={t("nameForm.nameForm")}
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  user="true"
                  error={formik.errors.name}
                  rel="noreferrer"
                />
                {formik.errors.name && formik.touched.name && (
                  <ErrorFoms>{formik.errors.name}</ErrorFoms>
                )}
              </ContainerInput>
              <ContainerInput scroll={scroll} input2="true">
                <HouseIcon />
                <Input
                  id="company"
                  name="company"
                  type="text"
                  placeholder={t("companyForm.companyForm")}
                  onChange={formik.handleChange}
                  value={formik.values.company}
                  house="true"
                  error={formik.errors.company}
                  rel="noreferrer"
                />
                {formik.errors.company && formik.touched.company && (
                  <ErrorFoms>{formik.errors.company}</ErrorFoms>
                )}
              </ContainerInput>
              <ContainerInput scroll={scroll} input3="true">
                <EmailIcon />
                <Input
                  id="email"
                  name="email"
                  type="text"
                  placeholder={t("emailForm.emailForm")}
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  error={formik.errors.email}
                  rel="noreferrer"
                />
                {formik.errors.email && formik.touched.email && (
                  <ErrorFoms>{formik.errors.email}</ErrorFoms>
                )}
              </ContainerInput>
              <ContainerInput lastInput="true" scroll={scroll}>
                <PencilIcon />
                <TextArea
                  id="message"
                  name="message"
                  type="text"
                  placeholder={t("messageForm.messageForm")}
                  onChange={formik.handleChange}
                  value={formik.values.message}
                  error={formik.errors.message}
                  rel="noreferrer"
                />
                {formik.errors.message && formik.touched.message && (
                  <ErrorFoms>{formik.errors.message}</ErrorFoms>
                )}
              </ContainerInput>

              {spinner ? (
                <Spinner />
              ) : (
                <Button type="submit" scroll={scroll}>
                  {t("buttonForm.buttonForm")}
                </Button>
              )}
            </ContainerForm>
          </form>
        </>
      )}
    </Container>
  );
};

export default Form;
